import { CourseType, LessonType } from '../../../types'

export const getCourseLessons = (course: CourseType) => {
  if (!course.modules) {
    return []
  }

  const allLessons: LessonType[] = []

  // Loop through modules, adding lessons to allLessons
  for (const modules of course.modules) {
    if (modules.lessons) {
      allLessons.push(...modules.lessons)
    }
  }

  return allLessons
}
